<template>
    <div class="p-4">
        <div class="flex items-center">
            <m-back-btn @click="$router.go(-1)"/>

            <button 
                @click="() => showDelete = true"
                v-if="this.$route.name == 'adminEditAchievmentLevel'"
                class="ml-auto text-red">
                <leg-icon icon="trash-outline"></leg-icon>
            </button>
        </div>

        <div :key="reRender">
            <div class=" w-full shadow-none mt-5 text-3xl pl-1 font-bold" v-content-editor="{initialContent : achievementLevel?.name ?? '', placeholder : 'Achievment Name', callback : (text) => achievementLevel.name = text}"></div>

            <b-form-group label="Level" class="mt-4" description="This field is required">
                <b-form-input placeholder="-" v-model="achievementLevel.level"></b-form-input>
            </b-form-group>

            <b-form-group label="Rank">
                <b-form-input placeholder="-" v-model="achievementLevel.description"></b-form-input>
            </b-form-group>

            <b-form-group label="Autoship Goal">
                <b-form-input placeholder="-" v-model="achievementLevel.cv_autoship_goal"></b-form-input>
            </b-form-group>

            <b-form-group label="Weak Leg Goal">
                <b-form-input placeholder="-" v-model="achievementLevel.cv_weak_leg_goal"></b-form-input>
            </b-form-group>

            <b-form-group label="Sponsorship Goal">
                <b-form-input placeholder="-" v-model="achievementLevel.sponsorship"></b-form-input>
            </b-form-group>

              <b-form-group label="Other Goal">
                <b-form-input placeholder="-" v-model="achievementLevel.other_goal"></b-form-input>
            </b-form-group>

            <b-form-group label="Income">
                <b-form-input placeholder="-" v-model="achievementLevel.income"></b-form-input>
            </b-form-group>
            
            <b-form-group label="Qualification">
                <b-form-input placeholder="-" v-model="achievementLevel.qualification"></b-form-input>
            </b-form-group>

            <b-form-group label="Reward">
                <b-form-input placeholder="-" v-model="achievementLevel.reward"></b-form-input>
            </b-form-group>
        </div>


        <m-submit-btn 
            class="w-80 max-w-80 mx-auto flex justify-center mt-5"
            :disabled="disableBtn"
            @click="nextProcess">
            {{this.$route.name == 'adminEditAchievmentLevel' ? 'Update' : 'Create'}}
        </m-submit-btn>

        <m-delete-confirmation :show="showDelete"  title="Delete Achievement Level" @cancel="() => showDelete = false" @continue="startDeletingLevel">
            <template slot="description">
                <p><b>Note : </b> Deleting this will result in the loss of all associated data.</p>
            </template>
        </m-delete-confirmation>

    </div>
</template>
<script>

/* Mixins */
import {achievementmixins} from '@/mixins/achievementmixins';

export default {
    mixins : [achievementmixins],
    data() {
        return {
            achievementLevel: {},
            reRender        : Math.random(),
            showDelete : false
        }
    },
    computed : {
        /* Disable next process button base on the condition */
        disableBtn() {
            if(!this.achievementLevel?.name) return true;
            if(this.achievementLevel?.level.toString() == '') return true;

            return false;
        }
    },
    methods : {
        /**
         * Start deleting achievement level
         */
        async startDeletingLevel() {
            this.deleteAchievementLevel({id : this.$route.params.id, callback : () => {
                this.$bvModal.hide('deleteAchievement');
                this.$router.go(-1)
            }})
        },
        /**
         * Update or create achievement
         */
        async nextProcess() {
            if(this.$route.name == 'adminEditAchievmentLevel') {
                this.updateAchievementLevel({params : this.achievementLevel, callback : () => this.$router.go(-1)});
            } else {
                this.createAchievementLevel({params : this.achievementLevel, callback : () => this.$router.go(-1)});
            }
        }
    },
    beforeMount() {
       if(this.$route.name == 'adminEditAchievmentLevel') {
            /** Get Achievement */
            const acCallback = (data) => {
                this.achievementLevel = data;

                this.reRender = Math.random();
            }

            this.getAchievementLevel({id : this.$route.params.id, callback : acCallback})
       }
    }
}
</script>